import React, { useEffect, useState } from "react";
import { PageHeader } from "components/ui";
import { Grid, Box } from "@mui/material";

import GriFormComponent from "components/customizedStandardsComponent/GriFormComponent";
import FreeTextInputComponent from "components/customizedStandardsComponent/FreeTextInputComponent";
import UploadEvidenceComponent from "components/customizedStandardsComponent/UploadEvidenceComponent";
import DownloadReport from "components/customizedStandardsComponent/DownloadReport";
import DownloadPostReviewGapForm from "components/customizedStandardsComponent/DownloadPostReviewGapForm";
import UploadPostReviewGapForm from "components/customizedStandardsComponent/UploadPostReviewGapForm";
import DownloadPostReviewReports from "components/customizedStandardsComponent/DownloadPostReviewReports";
import StandardsSelector from "components/customizedStandardsComponent/GriStandardsSelector";
import NavigationButtons from "helper/navigation/NavigationButtons";
import ReusableFormComponent from "components/customizedStandardsComponent/EsgFormComponent";
import UploadEvidenceReviewReports from "components/customizedStandardsComponent/UploadEvidenceReviewReports";
import ReportsReviewDialog from "components/customizedStandardsComponent/ReportsReviewDialog";

import {
  RELATIVE_COMMUNITY_SENSITIVITY_FORM,
  GENDER_IMPACT_ASSESSMENT_FORM,
  STAKEHOLDER_ENGAGEMENT_SUMMARY_FORM,
  LIVELIHOOD_IMPACT_ASSESSMENT_FORM,
  WORKER_WELFARE_AUDIT_FORM,
  GRIEVANCE_MANAGEMENT_REPORTING_FORM,
} from "data/forms/griFormSchema";

import {
  CLIMATE_IMPACT_STANDARDS,
  ENVIROMENTAL_COMPLIANCE_REPORTING,
} from "data/standards/griStandards";
import { useNavigate } from "react-router-dom";

import { FREE_TEXT_SOCIAL } from "data/prompts/freeTextPrompts";

import {
  socialComplianceReporting,
  legalFrameWork_Social,
  reportsAssesstmentOptionSocial,
} from "data/reports/relevantReports";

const SocialComplianceReporting = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [prevStep, setPrevStep] = useState(0);
  const [reportData, setReportData] = useState({
    selectedStandards: [],
    companyInfo: {},
  });
  const navigate = useNavigate();

  const [showReviewPopup, setShowReviewPopup] = useState(false);
  const [forceUpdate, setForceUpdate] = useState(0);

  const steps = [
    "Download Social Compliance Reporting",
    "Relative Community Sensitivity Form",
    "Free Text Social Input & Prompts",
    "Download Legal Framework Social",
    "Gender Impact Assessment",
    "Stakeholder Engagement Summary",
    "Livelihood Impact Assessment",
    "Worker Welfare Audit",
    "Grievance Management Reporting",
    "Upload Evidence and Review Reports",
    "Download Climate Impact Reports",
    "Upload Evidence and Review Reports (2)",
    "Download Gap Form",
    "Upload Gap Form",
    "Download Post-Review Reports",
  ];

  const handleNext = () => {
    setPrevStep(activeStep);
    setActiveStep((prev) => prev + 1);
  };

  useEffect(() => {
    if (activeStep === 11 && prevStep === 10) {
      setShowReviewPopup(true);
    }
    setForceUpdate((prev) => prev + 1);
  }, [activeStep, prevStep]);

  const handleSkipToDashboard = () => {
    setShowReviewPopup(false);
    navigate("/"); // Navigate to dashboard
  };

  const handleBack = () => {
    setPrevStep(activeStep);
    setActiveStep((prev) => prev - 1);
  };

  const handleSaveStandards = (selectedStandards) => {
    setReportData((prev) => ({
      ...prev,
      selectedStandards,
    }));
  };

  const handleClosePopup = () => {
    setShowReviewPopup(false);
  };

  const handleSkipToStep5 = () => {
    setPrevStep(activeStep);
    setActiveStep(7);
    setShowReviewPopup(false);
  };

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <DownloadReport
            key="social-compliance-step"
            onPrevious={handleBack}
            onNext={handleNext}
            initialItems={socialComplianceReporting}
            description="Download and review social compliance guidelines and frameworks"
            stepId="step-0"
            title="Social Compliance Reporting"
            ReportDownloadButtonShow={false}
          />
        );
      case 1:
        return (
          <ReusableFormComponent
            {...RELATIVE_COMMUNITY_SENSITIVITY_FORM}
            onNext={handleNext}
            onPrevious={handleBack}
            showPreviousButton={true}
            subtitle="Basic Project Setup/requirements"
          />
        );
      case 2:
        return (
          <FreeTextInputComponent
            stepData={FREE_TEXT_SOCIAL}
            onNext={handleNext}
            showSaveButton={true}
            showNextButton={true}
            titleColor="#02462E"
            subtitleColor="#02462E"
            formWidth={707}
          />
        );
      case 3:
        return (
          <DownloadReport
            key="legal-framework-step"
            onPrevious={handleBack}
            onNext={handleNext}
            initialItems={legalFrameWork_Social}
            description="Download and review legal framework guidelines"
            stepId="step-3"
            title="Legal and Framework Mapping (Based on Project Profile)"
            ReportDownloadButtonShow={false}
          />
        );
      case 4:
        return (
          <ReusableFormComponent
            {...GENDER_IMPACT_ASSESSMENT_FORM}
            onNext={handleNext}
            onPrevious={handleBack}
            showPreviousButton={true}
          />
        );
      case 5:
        return (
          <ReusableFormComponent
            {...STAKEHOLDER_ENGAGEMENT_SUMMARY_FORM}
            onNext={handleNext}
            onPrevious={handleBack}
            showPreviousButton={true}
          />
        );
      case 6:
        return (
          <ReusableFormComponent
            {...LIVELIHOOD_IMPACT_ASSESSMENT_FORM}
            onNext={handleNext}
            onPrevious={handleBack}
            showPreviousButton={true}
          />
        );
      case 7:
        return (
          <ReusableFormComponent
            {...WORKER_WELFARE_AUDIT_FORM}
            onNext={handleNext}
            onPrevious={handleBack}
            showPreviousButton={true}
          />
        );
      case 8:
        return (
          <ReusableFormComponent
            {...GRIEVANCE_MANAGEMENT_REPORTING_FORM}
            onNext={handleNext}
            onPrevious={handleBack}
            showPreviousButton={true}
          />
        );
      case 9:
        return (
          <UploadEvidenceComponent
            onPrevious={handleBack}
            onNext={handleNext}
            evidenceTypes={[]}
          />
        );
      case 10:
        return (
          <DownloadReport
            key="climate-impact-reports-step"
            onPrevious={handleBack}
            onNext={handleNext}
            initialItems={reportsAssesstmentOptionSocial}
            title="Download the report relevant to your requirements"
            description="Download and review generated climate impact reports"
            stepId="step-10"
            showReportCountdownButton={true}
          />
        );
      case 11:
        return (
          <UploadEvidenceReviewReports
            onPrevious={handleBack}
            onNext={handleNext}
          />
        );
      case 12:
        return (
          <DownloadPostReviewGapForm
            onPrevious={handleBack}
            onNext={handleNext}
          />
        );
      case 13:
        return (
          <UploadPostReviewGapForm
            onPrevious={handleBack}
            onNext={handleNext}
          />
        );
      case 14:
        return (
          <DownloadPostReviewReports
            onPrevious={handleBack}
            standardName="Social Compliance"
            showReportCountdownButton={true}
          />
        );
      default:
        return <div>Unknown step 🥲</div>;
    }
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <PageHeader title="AI-Powered ESG Reporting across Global, National, Sectoral, and Industry-Specific Standards" />
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <NavigationButtons
              imageKey="dashboardImg3_3"
              title="Social Compliance"
              activeStep={activeStep}
              onBack={handleBack}
            />
          </Box>
        </Grid>

        <Grid item xs={12}>
          {getStepContent(activeStep)}
        </Grid>

        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: 4,
              mb: 2,
            }}
          >
            {steps.map((_, index) => (
              <Box
                key={index}
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  backgroundColor: index <= activeStep ? "#02462E" : "#e0e0e0",
                  mx: 1,
                }}
              />
            ))}
          </Box>
        </Grid>
      </Grid>

      <ReportsReviewDialog
        open={showReviewPopup}
        onClose={handleClosePopup}
        onSkip={handleSkipToDashboard}
      />
    </>
  );
};

export default SocialComplianceReporting;
